import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  partners: [],
  partner: null,
};

// getters
export const getters = {
  partners: state => state.partners,
  partner: state => state.partner ? state.partner : {id: 0},
};

// mutations
export const mutations = {

  [types.FETCH_PARTNERS_SUCCESS] (state, { partners }) {
    state.partners = partners
  },

  [types.FETCH_PARTNERS_FAILURE] (state) {
    state.partners = null
  },

  [types.FETCH_ONE_PARTNER_SUCCESS] (state, { partner }) {
    state.partner = partner
  },

  [types.FETCH_ONE_PARTNER_FAILURE] (state) {
    state.partner = null
  },

  [types.CLEAR_PARTNER] (state) {
    state.partner = null
  },

  [types.ADD_PARTNER_SUCCESS] (state, { partner }) {
    if (state.partners) {
      state.partners.push(partner)
    } else {
      state.partners = [
        partner
      ]
    }
  },

  [types.REMOVE_PARTNER_SUCCESS] (state, { partnerId }) {
    if (state.partners) {
      state.partners.splice(state.partners.findIndex(el => el.id === partnerId), 1);
    } else {
      state.partners = null
    }
  },

  [types.UPDATE_PARTNER_SUCCESS] (state, { partner }) {
    if (!state.partners) {
      return;
    }
    let index = state.partners.findIndex(el => el.id === partner.id);

    if (index !== -1) {
      state.partners[index] = partner;
    }
  },

  [types.ADD_PARTNER_FAILURE] (state, { partner }) {
    state.partners = null
  },

  [types.REMOVE_PARTNER_FAILURE] (state, { partner }) {}
};

// actions
export const actions = {

  async fetchPartners ({ commit }) {
    try {
      const { data } = await axios.get('/api/partners');

      commit(types.FETCH_PARTNERS_SUCCESS, { partners: data })
    } catch (e) {
      commit(types.FETCH_PARTNERS_FAILURE)
    }
  },

  clearPartner () {
    commit(types.CLEAR_PARTNER);
  },

  async fetchPartner ({ commit }, { id }) {
    try {
      const { data } = await axios.get('/api/partners/' + id);

      commit(types.FETCH_ONE_PARTNER_SUCCESS, { partner: data })
    } catch (e) {
      commit(types.FETCH_ONE_PARTNER_FAILURE)
    }
  },

  addPartner ({ commit }, partner) {
    if (partner) {
      commit(types.ADD_PARTNER_SUCCESS, { partner: partner })
    } else {
      commit(types.ADD_PARTNER_FAILURE)
    }
  },

  updatePartner ({ commit }, partner) {
    if (partner) {
      commit(types.UPDATE_PARTNER_SUCCESS, { partner: partner })
    } else {
      commit(types.UPDATE_PARTNER_FAILURE)
    }
  },

  async removePartner ({ commit }, { partner }) {
    try {
      const { data } = await axios.delete('/api/partners/' + partner.id);

      commit(types.REMOVE_PARTNER_SUCCESS, { partnerId: partner.id })
    } catch (e) {
      commit(types.REMOVE_PARTNER_FAILURE)
    }
  },
};
